<template>
  <div v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">

      <div class="common-form">修改拍卖</div>

      <el-form-item label="名称" >
        <el-input v-model="form.auction_name" placeholder="请输入名称" class="max-w460"></el-input>
      </el-form-item>
       <el-form-item label="轮播图缩略图">
         <div>
           <el-button type="primary" @click="openUpload">上传图片</el-button>
           <img class="mt10" v-img-url="'image.file_path',form"  width="120px;" alt="" />
           <!--上传图片组件-->
           <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
         </div>
       </el-form-item>
      <el-form-item label="分类">
        <el-input v-model="form.auction_type" placeholder="请输入分类" type="number" maxlength="1" class="max-w460"></el-input>
        <div class="tips">类型：1.生日纪忆酒，2.大坛封藏酒，3.大师纪念酒，4.明星纪念酒</div>
      </el-form-item>

        <el-form-item label="编码 ">
          <el-input v-model="form.auction_number" placeholder="请输入编码" type="text" maxlength="10" class="max-w460"></el-input>
        </el-form-item>


      <el-form-item label="拍卖价"><el-input v-model="form.auction_price" placeholder="请输入拍卖价" type="number" maxlength="10" class="max-w460"></el-input></el-form-item>

      <el-form-item label="年份 " >
        <el-input v-model="form.auction_year" placeholder="请输入年份" type="number" maxlength="5" class="max-w460"></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="info" size="small" @click="cancelFunc" :loading="loading">取消</el-button>
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import AuctionApi from '@/api/auction.js';
import {formatModel} from '@/utils/base.js';
import Upload from '@/components/file/Upload';

export default {
  components: {
    /*图片上传*/
    Upload: Upload
  },
  data() {
    return {
      /*form表单数据*/
      isupload: false,

      form: {
        /*ID*/
        auction_id:'',
        /*名称*/
        auction_name:'',
        /*类型*/
        auction_type:'',
        auction_number:'',
        auction_price:'',
        auction_year:'',
        image_id: '',
        image:{},
      },
      list: {},
      //category: [],
      /*是否正在加载*/
      loading: true,

    };
  },
  created() {
    let auction_id = this.$route.query.auction_id;
    this.getData(auction_id);
  },

  methods: {
    getData(auction_id) {
      let self = this;
      AuctionApi.auctionDetail(
        {
          auction_id: auction_id
        },
        true
      )
        .then(data => {
          let obj={};
          obj = data.data.detail;
          //选中

          self.form=formatModel(self.form,obj);
         // self.category = res.data.catgory;
          self.loading=false;
        })
        .catch(error => {
          self.loading=false;
        });
    },
/*上传*/
    openUpload() {
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image.file_path = e[0].file_path;
      }
      this.isupload = false;
    },
    /*修改*/
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          AuctionApi.editAuction(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.$router.push('/plus/auction/index');
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          self.loading = false;
        }
      });
    },

    /*取消*/
    cancelFunc(){
      this.$router.push({
        path:'/plus/auction/index',
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-add {
  padding-bottom: 50px;
}

.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/auction/auction/edit.vue